import { useState, useEffect } from 'react';

/**
 * Custom hook to handle restaurant data in header
 * Consolidates restaurant state management
 */
export const useRestaurantHeader = ({ restaurantSuccess }) => {
  const [restaurant, setRestaurant] = useState(null);

  useEffect(() => {
    if (restaurantSuccess?.data) {
      setRestaurant(restaurantSuccess.data);
    }
  }, [restaurantSuccess?.data]);

  return { restaurant };
};

